import type { Transparency, ViewOption } from '@/engine/app/interfaces';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { ViewsService } from '@/engine/app/Views.service';

export class SetViewOptionTransparencyCommand implements ICommand {
  private readonly _viewsService: ViewsService;

  private readonly _viewOption: ViewOption;

  private readonly _transparency: Transparency;

  private _previousTransparency?: Transparency;

  public constructor(viewsService: ViewsService, viewOption: ViewOption, transparency: Transparency) {
    this._viewsService = viewsService;
    this._viewOption = viewOption;
    this._transparency = transparency;
  }

  public execute(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const object of objects) {
      if (this._viewOption.descriptors.includes(object.descriptor)) {
        this._previousTransparency = object.transparency;
        object.setTransparency(this._transparency);
      }
    }
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    if (this._previousTransparency === undefined) {
      return Promise.resolve(false);
    }
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const object of objects) {
      if (this._viewOption.descriptors.includes(object.descriptor)) {
        object.setTransparency(this._previousTransparency);
      }
    }
    return Promise.resolve(true);
  }
}
